import { Injectable } from "@angular/core";

@Injectable()
export class HighlightingFeaturesService {

    private activatedIcons: {'reset':Element, 'hl':Element}[] = [];
    private prevMap: {'center': ol.Coordinate, 'zoom': number};
    private animationDuration = 300;

    private buildHighlightLayer(url: string, color: string) {
        let layer = new ol.layer.Vector(
            {
                source: new ol.source.Vector({
                    url: url,
                    format: new ol.format.GeoJSON()
                }),
                style: new ol.style.Style({
                    fill: new ol.style.Fill({
                        color: color
                    }),
                    stroke: new ol.style.Stroke({
                        color: color,
                        width: 2
                    })
                })
            }
        );
        layer.setProperties({'id': 'hl-layer', 'zIndex': 900 }, true);
        return layer;
    }

    public fitToExtent(map: ol.Map, layer: ol.layer.Vector) {
        // hem d'esperar que es carreguin les feat per calcular l'extensió
        // font: https://gis.stackexchange.com/a/341680
        layer.getSource().on('addfeature', (e) => {
            let nlExtent = layer.getSource().getExtent();
            map.getView().fit(
                nlExtent, {
                    "padding": [0, 0, 0, 400], // pel panell d'info que fa 400px d'ample
                    "duration": this.animationDuration * 1.5 // així es diferencia el moviment de centrar (lent) i recuperar (ràpid)
                }
            );
        });
    }

    public moveMap(map: ol.Map, center: ol.Coordinate, zoom: number) {
        map.getView().animate({
            'zoom': zoom,
            'center': center,
            'duration': this.animationDuration
        });
    }

    private getHighlightingIcons(event: CustomEvent): {'reset':Element, 'hl':Element} {
        let resettingIcon: Element;
        let highlightingIcon: Element;

        try {
            resettingIcon = event.detail.icons[0];
            highlightingIcon = event.detail.icons[1];
        } catch (e) {
            console.error(e);
            console.error("L'esdeveniment llançat per un dels botons de resaltat d'elements de la info no té el format que esperat. Revisa l'arxiu featureinfo.xsl del backend")
            return undefined;
        }
        return {'reset': resettingIcon, 'hl': highlightingIcon};
    }

    private updateHighlighterIcons(action: string, icons: {'reset':Element, 'hl':Element}) {
        switch(action) {
            case "activate":
                for (let leftOverIcons of this.activatedIcons) this.updateHighlighterIcons("deactivate", leftOverIcons);
                icons.reset.className = "hl-layer-icon";
                icons.hl.className = "hl-layer-icon hl-layer-icon-activated"
                this.activatedIcons.push(icons);
                break;
            case "deactivate":
                icons.reset.className = "hl-layer-icon hide";
                icons.hl.className = "hl-layer-icon"
                break;
            default:
                console.error("Bug. No s'ha cridat bé updateHighlighterIcons");
        }
        
    }

    public getHighlightingParams(event: CustomEvent): {'color': string,'url': string} {
        try {
            let opacity = Number(event.detail.opacity);
            let opacity_s = Math.round(opacity * 255).toString(16)
            return {
                'color': event.detail.color + opacity_s,
                'url': event.detail.url
            }
        } catch(e) {
            console.error(e);
            return undefined;
        }
    }

    public getLayerById(map: ol.Map, id: string): ol.layer.Base {
        let allLayers = map.getLayers().getArray();
        for (let layer of allLayers) {
            if (layer.get("id") == id) return layer;
        }
        return undefined
    }

    public getLayersById(map: ol.Map, id: string): ol.layer.Base[] {
        let allLayers = map.getLayers().getArray();
        let layersWithSameId: ol.layer.Base[] = [];
        for (let layer of allLayers) {
            if (layer.get("id") == id) layersWithSameId.push(layer);
        }
        return layersWithSameId;
    }

    public removeLayersById(map: ol.Map, id: string) {
        this.getLayersById(map, id).forEach(layer => map.removeLayer(layer))
    }

    public highlightLayerHandler(map: ol.Map, event) {
        console.log(event.detail);
        this.prevMap = {'center': map.getView().getCenter(), 'zoom': map.getView().getZoom()};
        this.removeLayersById(map, "hl-layer");
        let params = this.getHighlightingParams(event);
        let new_layer = this.buildHighlightLayer(params.url, params.color);
        map.addLayer(new_layer);
        this.fitToExtent(map, new_layer);
        let icons = this.getHighlightingIcons(event);
        this.updateHighlighterIcons("activate", icons);
    }

    public highlightLayerResetHandler(map:ol.Map, event) {
        console.log(event.detail);
        this.removeLayersById(map, "hl-layer");
        let icons = this.getHighlightingIcons(event);
        this.updateHighlighterIcons("deactivate", icons);
        this.moveMap(map, this.prevMap.center, this.prevMap.zoom);
    }

}


// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/services/map/highlighting_features.ts